'use client';
import { getHotkeyHandler } from './parseHotkeys.js';
import { useWindowEvent } from '../useWindowEvent/useWindowEvent.js';

function shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable = false) {
    if (event.target instanceof HTMLElement) {
        if (triggerOnContentEditable) {
            return !tagsToIgnore.includes(event.target.tagName);
        }
        return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
    }
    return true;
}
const useHotkeys = (hotkeys, tagsToIgnore = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
], triggerOnContentEditable = false)=>{
    useWindowEvent('keydown', (event)=>{
        if (shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)) {
            getHotkeyHandler(hotkeys)(event);
        }
    });
};

export { useHotkeys };
//# sourceMappingURL=useHotkeys.js.map
